import { observer } from "mobx-react-lite";
import styled from "styled-components";

import { describeUsage } from "../../describeUsage.ts";
import { useStores } from "../../stores/RootStore.ts";
import { Button, Card, Muted, Page, Row, Title } from "../ui/primitives.tsx";
import { ProgressView } from "../ui/ProgressView.tsx";
import { StatusBadge } from "../ui/StatusBadge.tsx";

const WorkerCard = styled(Card).attrs({ as: "button" })`
    font: inherit;
    color: inherit;
    text-align: left;
    cursor: pointer;
`;

const TaskText = styled.span`
    font-weight: 600;
    overflow-wrap: anywhere;
`;

export const WorkerListPage = observer(function WorkerListPage() {
    const { workers, connection, ui } = useStores();

    return (
        <Page>
            <Row style={{ justifyContent: "space-between" }}>
                <Title>Workers</Title>
                <Button $primary onClick={() => ui.show({ name: "start" })}>
                    New task
                </Button>
            </Row>
            {[...workers.resources].map(([controller, { cpus, memory, maxWorkers }]) => (
                <Muted key={controller}>
                    {controller}: {workers.busy(controller)} of {maxWorkers} workers busy · {cpus} CPUs · {Math.round(memory / 1024 ** 3)}{" "}
                    GB memory
                </Muted>
            ))}
            {workers.usages.length > 0 && <Muted>All workers together: {describeUsage(workers.usages, connection.models)}</Muted>}
            {workers.list.length === 0 && <Muted>No workers yet. Start one with New task.</Muted>}
            {workers.list.map((worker) => (
                <WorkerCard key={worker.key} onClick={() => ui.show({ name: "worker", key: worker.key })}>
                    <Row style={{ justifyContent: "space-between" }}>
                        <TaskText>{worker.title || worker.id}</TaskText>
                        <StatusBadge exitCode={worker.exitCode} />
                    </Row>
                    {worker.progress && worker.running && <ProgressView progress={worker.progress} />}
                    {worker.usage && <Muted>{describeUsage([worker.usage], connection.models)}</Muted>}
                    <Muted>
                        on {worker.controller}, started {worker.startedAt ? new Date(worker.startedAt).toLocaleString() : "earlier"}
                    </Muted>
                </WorkerCard>
            ))}
        </Page>
    );
});
